<template>
  <div v-if="showBanner" :class="bannerClass" class="time-banner">
    <div class="banner-icon">
      <div class="banner-icon-one" v-if="type === 'trial-ending'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.0836 6.7599L12.1836 8.9599C12.3336 9.2599 12.7336 9.5599 13.067 9.6099L15.0586 9.94323C16.3336 10.1599 16.6336 11.0766 15.717 11.9932L14.167 13.5516C13.9086 13.8099 13.7586 14.3182 13.842 14.6849L14.2836 16.6099C14.6336 18.1266 13.8253 18.7182 12.4836 17.9266L10.617 16.8182C10.2753 16.6182 9.7253 16.6182 9.38364 16.8182L7.50864 17.9182C6.16697 18.7099 5.35864 18.1182 5.70864 16.6016L6.1503 14.6766C6.23364 14.3182 6.08364 13.8099 5.8253 13.5432L4.28364 12.0016C3.36697 11.0849 3.66697 10.1599 4.94197 9.95157L6.93364 9.61823C7.26697 9.5599 7.66697 9.26823 7.81697 8.96823L8.91697 6.76823C9.50864 5.56823 10.492 5.56823 11.0836 6.7599Z" fill="#FCFCFD"/>
          <path d="M5 8.1263C4.65833 8.1263 4.375 7.84297 4.375 7.5013V1.66797C4.375 1.3263 4.65833 1.04297 5 1.04297C5.34167 1.04297 5.625 1.3263 5.625 1.66797V7.5013C5.625 7.84297 5.34167 8.1263 5 8.1263Z" fill="#FCFCFD"/>
          <path d="M15 8.1263C14.6583 8.1263 14.375 7.84297 14.375 7.5013V1.66797C14.375 1.3263 14.6583 1.04297 15 1.04297C15.3417 1.04297 15.625 1.3263 15.625 1.66797V7.5013C15.625 7.84297 15.3417 8.1263 15 8.1263Z" fill="#FCFCFD"/>
          <path d="M10 3.95964C9.65833 3.95964 9.375 3.6763 9.375 3.33464V1.66797C9.375 1.3263 9.65833 1.04297 10 1.04297C10.3417 1.04297 10.625 1.3263 10.625 1.66797V3.33464C10.625 3.6763 10.3417 3.95964 10 3.95964Z" fill="#FCFCFD"/>
        </svg>
      </div>

      <div class="banner-icon-two" v-else-if="type === 'trial-expired'">
        <svg  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.0836 6.7599L12.1836 8.9599C12.3336 9.2599 12.7336 9.5599 13.067 9.6099L15.0586 9.94323C16.3336 10.1599 16.6336 11.0766 15.717 11.9932L14.167 13.5516C13.9086 13.8099 13.7586 14.3182 13.842 14.6849L14.2836 16.6099C14.6336 18.1266 13.8253 18.7182 12.4836 17.9266L10.617 16.8182C10.2753 16.6182 9.7253 16.6182 9.38364 16.8182L7.50864 17.9182C6.16697 18.7099 5.35864 18.1182 5.70864 16.6016L6.1503 14.6766C6.23364 14.3182 6.08364 13.8099 5.8253 13.5432L4.28364 12.0016C3.36697 11.0849 3.66697 10.1599 4.94197 9.95157L6.93364 9.61823C7.26697 9.5599 7.66697 9.26823 7.81697 8.96823L8.91697 6.76823C9.50864 5.56823 10.492 5.56823 11.0836 6.7599Z" fill="#FCFCFD"/>
          <path d="M5 8.1263C4.65833 8.1263 4.375 7.84297 4.375 7.5013V1.66797C4.375 1.3263 4.65833 1.04297 5 1.04297C5.34167 1.04297 5.625 1.3263 5.625 1.66797V7.5013C5.625 7.84297 5.34167 8.1263 5 8.1263Z" fill="#FCFCFD"/>
          <path d="M15 8.1263C14.6583 8.1263 14.375 7.84297 14.375 7.5013V1.66797C14.375 1.3263 14.6583 1.04297 15 1.04297C15.3417 1.04297 15.625 1.3263 15.625 1.66797V7.5013C15.625 7.84297 15.3417 8.1263 15 8.1263Z" fill="#FCFCFD"/>
          <path d="M10 3.95964C9.65833 3.95964 9.375 3.6763 9.375 3.33464V1.66797C9.375 1.3263 9.65833 1.04297 10 1.04297C10.3417 1.04297 10.625 1.3263 10.625 1.66797V3.33464C10.625 3.6763 10.3417 3.95964 10 3.95964Z" fill="#FCFCFD"/>
        </svg>
      </div>

      <div class="banner-icon-three" v-else-if="type === 'new-user'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.1414 4.07656L11.2581 1.90156C10.5414 1.5849 9.45807 1.5849 8.74141 1.90156L3.85807 4.07656C2.62474 4.62656 2.44141 5.37656 2.44141 5.77656C2.44141 6.17656 2.62474 6.92656 3.85807 7.47656L8.74141 9.65156C9.09974 9.8099 9.54974 9.89323 9.99974 9.89323C10.4497 9.89323 10.8997 9.8099 11.2581 9.65156L16.1414 7.47656C17.3747 6.92656 17.5581 6.17656 17.5581 5.77656C17.5581 5.37656 17.3831 4.62656 16.1414 4.07656Z" fill="#FCFCFD"/>
          <path d="M10.0003 14.2013C9.68359 14.2013 9.36693 14.1346 9.07526 14.0096L3.45859 11.5096C2.60026 11.1263 1.93359 10.1013 1.93359 9.15964C1.93359 8.81797 2.20859 8.54297 2.55026 8.54297C2.89193 8.54297 3.16693 8.81797 3.16693 9.15964C3.16693 9.60964 3.54193 10.193 3.95859 10.3763L9.57526 12.8763C9.84193 12.993 10.1503 12.993 10.4169 12.8763L16.0336 10.3763C16.4503 10.193 16.8253 9.61797 16.8253 9.15964C16.8253 8.81797 17.1003 8.54297 17.4419 8.54297C17.7836 8.54297 18.0586 8.81797 18.0586 9.15964C18.0586 10.093 17.3919 11.1263 16.5336 11.5096L10.9169 14.0096C10.6336 14.1346 10.3169 14.2013 10.0003 14.2013Z" fill="#FCFCFD"/>
          <path d="M10.0003 18.3341C9.68359 18.3341 9.36693 18.2674 9.07526 18.1424L3.45859 15.6424C2.53359 15.2341 1.93359 14.3091 1.93359 13.2924C1.93359 12.9508 2.20859 12.6758 2.55026 12.6758C2.89193 12.6758 3.16693 12.9508 3.16693 13.2924C3.16693 13.8174 3.47526 14.2924 3.95859 14.5091L9.57526 17.0091C9.84193 17.1258 10.1503 17.1258 10.4169 17.0091L16.0336 14.5091C16.5086 14.3008 16.8253 13.8174 16.8253 13.2924C16.8253 12.9508 17.1003 12.6758 17.4419 12.6758C17.7836 12.6758 18.0586 12.9508 18.0586 13.2924C18.0586 14.3091 17.4586 15.2258 16.5336 15.6424L10.9169 18.1424C10.6336 18.2674 10.3169 18.3341 10.0003 18.3341Z" fill="#FCFCFD"/>
        </svg>
      </div>

      <div class="banner-icon-four" v-else-if="type === 'subscription-ended'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.8415 4.5763V5.19297L11.8915 3.48464C10.7749 2.84297 9.21654 2.84297 8.1082 3.48464L5.1582 5.2013V4.5763C5.1582 2.7013 6.1832 1.66797 8.0582 1.66797H11.9415C13.8165 1.66797 14.8415 2.7013 14.8415 4.5763Z" fill="#FCFCFD"/>
          <path d="M14.866 6.64089L14.7494 6.58255L13.616 5.93255L11.266 4.57422C10.5493 4.15755 9.44935 4.15755 8.73268 4.57422L6.38268 5.92422L5.24935 6.59089L5.09935 6.66589C3.64102 7.64922 3.54102 7.83255 3.54102 9.40755V13.1742C3.54102 14.7492 3.64102 14.9326 5.13268 15.9409L8.73268 18.0159C9.09102 18.2326 9.54102 18.3242 9.99935 18.3242C10.4493 18.3242 10.9077 18.2242 11.266 18.0159L14.8993 15.9159C16.366 14.9326 16.4577 14.7576 16.4577 13.1742V9.40755C16.4577 7.83255 16.3577 7.64922 14.866 6.64089ZM12.3243 11.2492L11.816 11.8742C11.7327 11.9659 11.6743 12.1409 11.6827 12.2659L11.7327 13.0659C11.766 13.5576 11.416 13.8076 10.9577 13.6326L10.216 13.3326C10.0993 13.2909 9.90768 13.2909 9.79102 13.3326L9.04935 13.6242C8.59102 13.8076 8.24102 13.5492 8.27435 13.0576L8.32435 12.2576C8.33268 12.1326 8.27435 11.9576 8.19102 11.8659L7.67435 11.2492C7.35768 10.8742 7.49935 10.4576 7.97435 10.3326L8.74935 10.1326C8.87435 10.0992 9.01602 9.98255 9.08268 9.88255L9.51602 9.21589C9.78268 8.79922 10.2077 8.79922 10.4827 9.21589L10.916 9.88255C10.9827 9.99089 11.1327 10.0992 11.2493 10.1326L12.0243 10.3326C12.4993 10.4576 12.641 10.8742 12.3243 11.2492Z" fill="#FCFCFD"/>
        </svg>
      </div>

      <div class="banner-icon-six" v-else-if="type === 'downgrade-warning'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 1.66797C5.40002 1.66797 1.66669 5.4013 1.66669 10.0013C1.66669 14.6013 5.40002 18.3346 10 18.3346C14.6 18.3346 18.3334 14.6013 18.3334 10.0013C18.3334 5.4013 14.6 1.66797 10 1.66797ZM10 11.2513C9.65835 11.2513 9.37502 10.968 9.37502 10.6263V6.66797C9.37502 6.3263 9.65835 6.04297 10 6.04297C10.3417 6.04297 10.625 6.3263 10.625 6.66797V10.6263C10.625 10.968 10.3417 11.2513 10 11.2513ZM10.7667 13.5763C10.725 13.6846 10.6667 13.7763 10.5917 13.8596C10.5084 13.9346 10.4167 13.993 10.3167 14.0346C10.2167 14.0763 10.1084 14.0846 10 14.0846C9.89169 14.0846 9.78335 14.0763 9.68335 14.0346C9.58335 13.993 9.49169 13.9346 9.40835 13.8596C9.33335 13.7763 9.27502 13.6846 9.23335 13.5763C9.19169 13.4763 9.16669 13.368 9.16669 13.2596C9.16669 13.1513 9.19169 13.043 9.23335 12.943C9.27502 12.8346 9.33335 12.743 9.40835 12.6596C9.49169 12.5846 9.58335 12.5263 9.68335 12.4846C9.88335 12.4013 10.1167 12.4013 10.3167 12.4846C10.4167 12.5263 10.5084 12.5846 10.5917 12.6596C10.6667 12.743 10.725 12.8346 10.7667 12.943C10.8084 13.043 10.8334 13.1513 10.8334 13.2596C10.8334 13.368 10.8084 13.4763 10.7667 13.5763Z" fill="#FCFCFD"/>
        </svg>
      </div>

      <div class="banner-icon-five" v-else-if="type === 'payment-reminder'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.7493 12.5234C13.9077 12.5234 12.416 14.0151 12.416 15.8568C12.416 17.6984 13.9077 19.1901 15.7493 19.1901C17.591 19.1901 19.0827 17.6984 19.0827 15.8568C19.0827 14.0151 17.591 12.5234 15.7493 12.5234ZM17.0827 17.2318C16.9577 17.3568 16.7993 17.4151 16.641 17.4151C16.4827 17.4151 16.3243 17.3568 16.1993 17.2318L15.7577 16.7901L15.2993 17.2484C15.1743 17.3734 15.016 17.4318 14.8577 17.4318C14.6993 17.4318 14.541 17.3734 14.416 17.2484C14.1743 17.0068 14.1743 16.6068 14.416 16.3651L14.8743 15.9068L14.4327 15.4651C14.191 15.2234 14.191 14.8234 14.4327 14.5818C14.6743 14.3401 15.0743 14.3401 15.316 14.5818L15.7577 15.0234L16.1743 14.6068C16.416 14.3651 16.816 14.3651 17.0577 14.6068C17.2993 14.8484 17.2993 15.2484 17.0577 15.4901L16.641 15.9068L17.0827 16.3484C17.3243 16.5901 17.3243 16.9901 17.0827 17.2318Z" fill="#FCFCFD"/>
          <path d="M18.3327 6.29036V6.66536C18.3327 7.1237 17.9577 7.4987 17.4993 7.4987H2.49935C2.04102 7.4987 1.66602 7.1237 1.66602 6.66536V6.28203C1.66602 4.3737 3.20768 2.83203 5.11602 2.83203H14.8743C16.7827 2.83203 18.3327 4.38203 18.3327 6.29036Z" fill="#FCFCFD"/>
          <path d="M1.66602 9.58385V13.7172C1.66602 15.6255 3.20768 17.1672 5.11602 17.1672H10.3327C10.816 17.1672 11.2327 16.7589 11.191 16.2755C11.0743 15.0005 11.4827 13.6172 12.616 12.5172C13.0827 12.0589 13.6577 11.7089 14.2827 11.5089C15.3243 11.1755 16.3327 11.2172 17.2243 11.5172C17.766 11.7005 18.3327 11.3089 18.3327 10.7339V9.57552C18.3327 9.11719 17.9577 8.74219 17.4993 8.74219H2.49935C2.04102 8.75052 1.66602 9.12552 1.66602 9.58385ZM6.66602 14.3755H4.99935C4.65768 14.3755 4.37435 14.0922 4.37435 13.7505C4.37435 13.4089 4.65768 13.1255 4.99935 13.1255H6.66602C7.00768 13.1255 7.29102 13.4089 7.29102 13.7505C7.29102 14.0922 7.00768 14.3755 6.66602 14.3755Z" fill="#FCFCFD"/>
        </svg>
      </div>

      <div class="banner-close" @click="handleClose">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="#545560" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

    <div class="banner-content">
      <span v-if="type === 'trial-ending'" class="trial-ending">
        <span class="banner-text">{{ getBannerText() }}</span>
        <span class="banner-text-small">{{ getBannerSubText() }}</span>
        <button @click="handleUpgrade" class="banner-button">{{ getBannerButtonText() }}</button>
      </span>

      <span v-else-if="type === 'trial-expired'" class="trial-expired">
        <span class="banner-text">{{ getBannerText() }}</span>
        <span class="banner-text-small">{{ getBannerSubText() }}</span>
        <button @click="handleUpgrade" class="banner-button">{{ getBannerButtonText() }}</button>
      </span>

      <span v-else-if="type === 'new-user'" class="new-user">
        <span class="banner-text">{{ getBannerText() }}</span>
        <span class="banner-text-small">{{ getBannerSubText() }}</span>
        <button @click="handleUpgrade" class="banner-button">{{ getBannerButtonText() }}</button>
      </span>

      <span v-else-if="type === 'subscription-ended'" class="subscription-ended">
        <span class="banner-text">{{ getBannerText() }}</span>
        <span class="banner-text-small">{{ getBannerSubText() }}</span>
        <button @click="handleUpgrade" class="banner-button">{{ getBannerButtonText() }}</button>
      </span>

      <span v-else-if="type === 'payment-reminder'" class="payment-reminder">
        <span class="banner-text">{{ getBannerText() }}</span>
        <span class="banner-text-small">{{ getBannerSubText() }}</span>
        <button @click="handleUpgrade" class="banner-button">{{ getBannerButtonText() }}</button>
      </span>

      <span v-else-if="type === 'downgrade-warning'" class="downgrade-warning">
        <span class="banner-text">{{ $t('downgrade_warning_title') }}</span>
        <span class="banner-text-small">{{ $t('downgrade_warning_text') }}</span>
        <button @click="handleClose" class="banner-button">{{ $t('downgrade_warning_dismiss') }}</button>
      </span>

      <span v-else-if="type === 'payment-pending'" class="payment-pending">
        <span class="banner-text">{{ packageStatus?.message || $t('payment_pending_title') }}</span>
        <span class="banner-text-small">{{ packageStatus?.subMessage || $t('payment_pending_text') }}</span>
        <button @click="handleUpgrade" class="banner-button">{{ packageStatus?.buttonText || $t('payment_pending_button') }}</button>
      </span>
    </div>

  </div>
</template>

<script>
export default {
  name: 'TimeBanner',
  props: {
    type: {
      type: String,
      default: 'trial-ending',
      validator: (value) => [
        'trial-ending',
        'trial-expired',
        'new-user',
        'subscription-ended',
        'payment-reminder',
        'downgrade-warning',
        'payment-pending'
      ].includes(value)
    },
    show: {
      type: Boolean,
      default: true
    },
    packageStatus: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      showBanner: this.show
    }
  },

  computed: {
    bannerClass() {
      const baseClass = 'banner-base'

      switch (this.type) {
        case 'trial-ending':
          return `${baseClass} banner-purple`
        case 'trial-expired':
          return `${baseClass} banner-orange`
        case 'new-user':
          return `${baseClass} banner-blue`
        case 'subscription-ended':
          return `${baseClass} banner-dark-orange`
        case 'payment-reminder':
          return `${baseClass} banner-dark-red`
        case 'downgrade-warning':
          return `${baseClass} banner-info`
        case 'payment-pending':
          return `${baseClass} banner-orange`
        default:
          return `${baseClass} banner-purple`
      }
    }
  },

  methods: {
    handleUpgrade() {
      try {
        this.$emit('upgrade-clicked', {
          type: this.type,
          packageStatus: this.packageStatus || {}
        })
      } catch (error) {
      }
    },

    handleSelectPlan() {
      try {
        this.$emit('plan-select-clicked', {
          type: this.type,
          packageStatus: this.packageStatus || {}
        })
      } catch (error) {
      }
    },

    handleClose() {
      try {
        this.showBanner = false
        this.$emit('close', this.type)
      } catch (error) {
        this.showBanner = false
      }
    },

    getBannerText() {
      try {
        // Backend mesajı varsa onu kullan
        if (this.packageStatus?.message) {
          return this.packageStatus.message;
        }

        // Fallback: Backend mesajı yoksa yerel mesaj oluştur
        const daysLeft = (this.packageStatus && this.packageStatus.daysRemaining) ? this.packageStatus.daysRemaining : 0;
        const endDate = this.packageStatus?.expired_at || this.packageStatus?.endDate || '';
        const formattedEndDate = endDate ? this.formatDate(endDate) : '';

        switch (this.type) {
          case 'trial-ending':
            if (daysLeft > 1) {
              return formattedEndDate
                  ? `Deneme süreniz ${formattedEndDate} tarihinde sona eriyor (${daysLeft} gün kaldı)`
                  : `${daysLeft} gün içinde deneme süresi bitiyor`;
            }
            return formattedEndDate
                ? `Deneme süreniz ${formattedEndDate} tarihinde sona eriyor`
                : 'Deneme süresi yakında bitiyor';
          case 'trial-expired':
            return formattedEndDate
                ? `Deneme süreniz ${formattedEndDate} tarihinde sona erdi`
                : 'Deneme süresi bitti';
          case 'new-user':
            return 'Kullanıcı limiti aşıldı'
          case 'subscription-ended':
            return formattedEndDate
                ? `Abonelik ${formattedEndDate} tarihinde sona erdi`
                : 'Abonelik sona erdi';
          case 'payment-reminder':
            return 'Ödeme alınamadı'
          default:
            return 'Bildirim'
        }
      } catch (error) {
        return 'Bildirim'
      }
    },

    formatDate(dateStr) {
      try {
        if (!dateStr) return '';
        // "14.01.2026" veya "2026-01-14 00:00:00" formatını handle et
        if (dateStr.includes('.')) {
          return dateStr; // Zaten formatlanmış
        }
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
        return date.toLocaleDateString('tr-TR');
      } catch {
        return dateStr;
      }
    },

    getBannerSubText() {
      try {
        // Backend mesajı varsa onu kullan
        if (this.packageStatus?.subMessage) {
          return this.packageStatus.subMessage;
        }

        // Fallback: Backend mesajı yoksa yerel mesaj kullan
        switch (this.type) {
          case 'trial-ending':
            return 'Tüm özellikleri kullanmaya devam edin'
          case 'trial-expired':
            return 'Erişimi kaybetmemek için yükseltin'
          case 'new-user':
            return 'Yükseltme yapın veya kullanıcı satın alın'
          case 'subscription-ended':
            return 'Öğrenmeye devam etmek için plan seçin'
          case 'payment-reminder':
            return 'Kesintisiz erişim için ödeme bilgilerini güncelleyin'
          default:
            return ''
        }
      } catch (error) {
        return ''
      }
    },

    getBannerButtonText() {
      try {
        // Backend mesajı varsa onu kullan
        if (this.packageStatus?.buttonText) {
          return this.packageStatus.buttonText;
        }

        // Fallback: Backend mesajı yoksa yerel mesaj kullan
        switch (this.type) {
          case 'trial-ending':
          case 'trial-expired':
          case 'new-user':
            return 'Planı Yükselt'
          case 'subscription-ended':
            return 'Plan Seç'
          case 'payment-reminder':
            return 'Ödeme Ayarları'
          default:
            return 'Yükselt'
        }
      } catch (error) {
        return 'Yükselt'
      }
    }
  },

  watch: {
    show(newVal) {
      try {
        this.showBanner = newVal
      } catch (error) {
        this.showBanner = false
      }
    }
  }
}
</script>

<style scoped>
.time-banner {
  width: 100%;
  position: relative;
}

.banner-base {
  display: flex;
  align-items: center;
  padding: 16px 30px 16px 30px;
  gap: 12px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  position: relative;
}

.banner-purple {
  background-color: #e9e2ff;
}

.banner-orange {
  background-color: #fbdfb1;
}

.banner-blue {
  background-color: #c2d6ff;
}

.banner-dark-orange {
  background-color: #ffdac2;
}

.banner-dark-red {
  background-color: #f8c9d2;
}

.banner-info {
  background-color: #D1E9FF;
}

.banner-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: white;
}

.banner-content {
  flex: 1;
  color: white;
}

.banner-close {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-close:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.banner-button {
  background: none;
  border: none;
  color: black;
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  line-height: inherit;
  font-family: "euclid-regular", sans-serif;
}

.banner-button:hover {
  text-decoration: none;
  opacity: 0.9;
}

@media screen and (max-width: 768px) {
  .banner-base {
    padding: 10px 12px;
    font-size: 13px;
    gap: 10px;
  }

  .banner-icon {
    width: 20px;
    height: 20px;
  }

  .banner-close {
    right: 12px;
  }
}

@media screen and (max-width: 480px) {
  .banner-base {
    padding: 8px 10px;
    font-size: 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    position: relative;
  }

  .banner-content {
    width: 100%;
  }

  .banner-close {
    top: 8px;
    right: 8px;
    transform: none;
  }
}

.banner-text{
  color: #0E121B;
  font-family: "euclid-regular", sans-serif;
  font-weight: 600;
}

.banner-text-small{
  color: #545560;
  font-family: "euclid-regular", sans-serif;
  font-weight: 400;
}

.banner-icon-one,
.banner-icon-two,
.banner-icon-three,
.banner-icon-four,
.banner-icon-five,
.banner-icon-six {
  display: flex;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.banner-icon-one {
  background: #b5aaff;
}

.banner-icon-two {
  background: #f2ae40;
}

.banner-icon-three {
  background: #385dfb;
}

.banner-icon-four {
  background: #f17b2c;
}

.banner-icon-five {
  background: #df2241;
}

.banner-icon-six {
  background: #1570EF;
}

.downgrade-warning {
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.payment-pending {
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.banner-icon svg {
  width: 18px;
  height: 18px;
}

.payment-reminder{
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.subscription-ended{
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.new-user{
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.trial-expired{
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.trial-ending{
  display: flex;
  flex-direction: row;
  gap: 5px;
}
</style>
